document.addEventListener('DOMContentLoaded', () => {
    const mobileMenuButton = document.getElementById('mobile__menu_button');
    const mobileMenuCloseButton = document.getElementById('mobile__menu_close_button');
    const mobileMenu = document.getElementById('mobile__menu');

    mobileMenuButton.addEventListener('click', () => {
        mobileMenu.classList.remove('-translate-x-full');
    });

    mobileMenuCloseButton.addEventListener('click', () => {
        mobileMenu.classList.add('-translate-x-full');
    });

    const mobileMenuLinks = document.querySelectorAll('.menu-dropdown');
    mobileMenuLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();

            const parentLi = link.parentElement;
            const submenu = parentLi.querySelector('.menu-dropdown-content');
            const chevronIcon = link.querySelector('svg');

            if (submenu) {
                submenu.classList.toggle('hidden');
                chevronIcon.classList.toggle('rotate-180');
            }
        })
    })
});